<template>
  <div class="md-layout-item md-size-100">
    <md-card v-if="isCard">
      <md-card-content>
        <EmptyStateCore :stateType="stateType"
                        :label="label"
                        :description="description"
                        :customLabel="customLabel"
                        :customDescription="customDescription"
                        :buttonLabel="buttonLabel"
                        :buttonIcon="buttonIcon"
                        :mdRounded="mdRounded"
                        @click="click" />
      </md-card-content>
    </md-card>

    <EmptyStateCore v-else
                    :stateType="stateType"
                    :label="label"
                    :description="description"
                    :customLabel="customLabel"
                    :customDescription="customDescription"
                    :buttonLabel="buttonLabel"
                    :buttonIcon="buttonIcon"
                    :mdRounded="mdRounded"
                    @click="click"/>
  </div>
</template>

<script>
  /*
  Use: in component:  EmptyState: require('@/customcontrols/emptyState/emptyState.vue').default,
  <div v-else class="md-layout-item md-size-100">
    <EmptyState stateType="data" />
  </div>
  */
  export default {
    name: "EmptyState",
    components: {
      EmptyStateCore: require('./emptyStateCore.vue').default,
    },
    props: {
      isCard: {
        type: Boolean,
        default: false
      },
      stateType: {
        type: String,
        default: "data",
      },
      label: {
        type: String,
        default: null,
      },
      description: {
        type: String,
        default: null,
      },
      buttonLabel: {
        type: String,
        defualt: null
      },      
      buttonIcon: {
        type: String,
        defualt: null
      },
      customLabel: {
        type: String,
        defualt: null
      },
      customDescription: {
        type: String,
        defualt: null
      },
      mdRounded: {
        type: Boolean,
        defualt: false
      },
    },
    data: function () {
      return {};
    },
    methods: {
      click(e) {
        //console.log("clicked", e)
        this.$emit('click', e);
      }
    },
  };
</script>
<style></style>
